import React, { useMemo } from 'react';
import { Box, Option, ShimmerBox, Text } from '@common-fe/common-fe';

import { OptionKey } from '@/common/types';

import { PlanOption } from '../EmployerDashboard.types';

import PlanSelectDropdown from './PlanSelectDropdown';
interface Props {
  options: PlanOption[];
  isLoading?: boolean;
  foundPlan?: PlanOption;

  value: OptionKey | null;
  onChangeValue: (value: OptionKey) => void;
}
const AccountUsageTopbarContainer: React.FC<Props> = ({
  foundPlan,
  options = [],
  isLoading,
  value,
  onChangeValue,
}) => {
  const formattedOptions = useMemo(() => {
    return options.map(
      (option): Option => ({
        key: option.id,
        title: option.name,
      })
    );
  }, [options]);
  if (isLoading || !foundPlan) {
    return (
      <Box
        direction="row"
        align="center"
        justify="between"
        pad={{ vertical: 'spacing2' }}
        data-testid="account-usage-topbar_loading"
      >
        <ShimmerBox width="150px" height="44px" round="checkboxRound" />

        <ShimmerBox width="258px" height="40px" round="checkboxRound" />
      </Box>
    );
  }
  return (
    <Box
      direction="row"
      align="center"
      justify="between"
      pad={{ vertical: 'spacing2' }}
      data-testid="account-usage-topbar"
    >
      <Box margin={{ right: '100px' }}>
        <Text
          size="3xl"
          weight={700}
          truncate
          title={foundPlan?.name}
          data-testid="account-usage-topbar_plan-name"
        >
          {foundPlan?.name} Usage
        </Text>
      </Box>
      <Box width={{ max: '250px' }} fill>
        <PlanSelectDropdown value={value} onChange={onChangeValue} options={formattedOptions} />
      </Box>
    </Box>
  );
};
export default AccountUsageTopbarContainer;
